import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "./baseQuery";

/**
 * Empty API base that will be injected with endpoints from OpenAPI codegen.
 * This serves as the foundation for auto-generated RTK Query endpoints.
 */
export const generatedApi = createApi({
  reducerPath: "generatedApi",
  baseQuery,
  endpoints: () => ({}),
  tagTypes: [], // Will be populated by generated endpoints
});

export const { enhanceEndpoints } = generatedApi;
